// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SaveCart: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13">
            <path
                fill="CurrentColor"
                d="M24.7499996,0.75 L24.7499996,0 L23.2499996,0 L23.2499996,0.75 L23.2499996,6.43828154 L21.5296873,4.71796918 L20.9999996,4.18828154 L19.9382808,5.25 L20.4679685,5.77968764 L23.4679685,8.77968764 L24,9.31171846 L24.5296876,8.78203082 L27.5296876,5.78203082 L28.0617185,5.25 L27,4.18828154 L26.4703124,4.71796882 L24.75,6.43828154 L24.75,0.75 L24.7499996,0.75 Z M18,12 L30,12 L30,8.25 L26.1210938,8.25 L25.0593753,9.31171846 L24,10.3710938 L22.9382812,9.30937529 L21.8789062,8.25 L18,8.25 L18,12 Z M28.125,9.5625 C28.4356599,9.5625 28.6875,9.81434011 28.6875,10.125 C28.6875,10.4356599 28.4356599,10.6875 28.125,10.6875 C27.8143401,10.6875 27.5625,10.4356599 27.5625,10.125 C27.5625,9.81434011 27.8143401,9.5625 28.125,9.5625 Z"
                opacity=".66"
                transform="translate(-18 .5)"
            />
        </svg>
    );
};

export default React.memo(SaveCart);
